import { AMPPA_AUTH } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState } from "../../types";

export interface LoginState extends BaseAsyncReducerState {
    success: boolean;
    data: {
        roll: string
    }
    token?: string;
    user_profile_id?: string;
    exp?: number;
}

const initialState: LoginState = {
    token: "",
    loading: false,
    error: false,
    success: false,
    data: {
        roll: ''
    },
    user_profile_id: undefined,
}
  

function amppaAuthReducer(state = initialState, action: AppAction): LoginState | BaseAsyncReducerState | Record<string, unknown> {

    const { payload } = action;

    switch (action.type) {
        case AMPPA_AUTH.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
            }
        case AMPPA_AUTH.SUCCESS:

            return {
                ...state,
                ...payload,
                loading: false,
                error: false,

            }

        case AMPPA_AUTH.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}



export default amppaAuthReducer;